export default {
  header: {
    header_home: 'Home',
    header_development_document: 'Development documentation',
  },
  title: {
    CreationAddress:'Creation address',
    createUser: 'Create user',
    browser: 'Browser',
    Main_chain_block_height: 'Main Chain Block Height',

    no_deal_found: 'Transation not found',
    session: 'Session',
    current_committee_rounds: 'Current committee rounds',
    committee_information: 'Committee information',
    whole_network_transaction: 'Whole network transaction',
    consensus_committee_candidate_round: 'Consensus Committee Candidate Round',
    current_block_height: 'Current block height',
    details: ' details',
    intra_block_transactions: 'Intra-block transactions',
    block_height: ' block height',
    current_total: 'Current total',
    transactions: 'transactions',
    hold_details: 'Hold details',
    external_transaction: 'External transaction',
    Inside_transaction: 'Internal transaction',
    node_information: 'Node information',
    node_information: 'Node information',
    welcome_to_Blockchain_Explorer: 'Welcome to XXX Blockchain Explorer',
    management_fee: 'Management fee',
    chain_details: 'Chain details',
    node_status: 'Node status',
    more: 'More',
    node: 'Node',
    inquire: 'Search',
    transform: 'transform',
    contract_token_details: 'Contract token details',
    current_address_holdings_of_each_token: 'Current address holdings of each token',
    transfer: 'Transfer',
    other_token_transfer: 'Other token transfer',
    token_name: 'Token name',
    icon: 'Icon',
    token_details: 'Token details',
    billion: 'Billion',
    mining_pool: 'Consenseus node(Mining Pool)>',
    mining_pool_name: 'Pool name',
    mining_pool_2: 'Consenseus node(Mining Pool)',
    mining_pool_node: 'Consenseus node(Mining Pool)',
    mining_pool_detail: 'Consenseus node(Mining Pool) details',
    data_node: "Data node >",
    data_node_2: "Data node",
    data_node_detail: "Data node details",
    consensus_node: "Consenseus node(Alone) >",
    consensus_node_2: "Consenseus node(Alone)",
    consensus_node_detail: "Consenseus node(Alone) details",
    task_chain: 'Task chain',
    // trading_chain:'Transaction chain',
    trading_chain: 'Account chain',
    trading_height: 'Transaction list',
    blockchain_details: 'Blockchain details',
    transaction_details: 'Transaction Details',
    block_details: 'Block details',
    block_details_query: 'Block details query',
    transaction_details_inquiry: 'Transaction Search',
    thk_price: 'TKT price',
    network_market_value: 'Network market value',
    total_online_transaction_volume: 'Total transaction volume',
    view_transaction: 'View all transactions',
    trading_information: 'Trading Information',
    trading_count: 'Number of transactions',
    main_chain: 'Main chain',
    main_chain_mining: 'Main chain mining',
    block_height: 'Block height',
    block: 'Block',
    transaction: 'Transaction',
    current_committee_member: 'Current committee members',
    number_of_sub_chains: 'Task chain number',
    split_subchain: 'Sharded task chain',
    split_subchain_id: 'Transaction Chain ID',
    unfragmented_subchain: 'Unsharded task chain',
    see_more_deals: 'More deals',
    miner: 'Miner',
    whole_network_transaction_information: 'Entire network',
    block_information: 'Block information',
    slice_chain_information: 'Trading chain information',
    slice_chain_transaction_information: 'Transaction information',
    current_chain_transaction_information: 'Transaction information of this chain',
    mining_reward: 'Mining rewards',
    parent_block_hash: 'Parent block hash',
    participation_round: 'Candidate round',
    number_of_committees: 'Number of committees',
    participant_member_details: 'Candidate details',
    input_data: 'Input data',
    inverse_solution: 'Inverse solution Data',
    address_de: 'Address details',
    amount: 'Amount',
    check_content: 'Check content',
    rpt: 'Related party transactions',
    return_address: 'Return address',
    look_over: 'View',
    mine_number: 'Mining pools >',
    view_all: 'View all >',
    by: 'By',
    to: 'To',
    unpack: 'Bale',
    unpack_node: 'Packaging node',
    block_contains: 'Block contains',
    transactions: 'Transaction',
    chainId: 'Chain ID',
    viewMores: 'display more',
    all: 'All',
    transfer_out: 'Roll out',
    transfer_into: 'Transfer into',
    cross_chain_transfer: 'Cross-chain transfer',
    related_to_me: 'Related to me',
    success: 'Success', //failure
    failure: 'Failure',
    Sent_awaiting_verification: 'Sent, awaiting verification',
    locked: '',
    pos_locking: 'PoS lock',
    // pos_reward_chain: 'PoS award chain',
    pos_reward_chain: 'PoS chain',
    new_ecology_business_chain: 'Business chain',
    amount_detail: 'Amount breakdown',
    from: 'From',
    transfer_to: 'Transfer to',
    receiving_address: 'Receiving address',
    prize_amount: 'Prize amount',
    redemption_address: 'Redemption address',
    redemption_amount: 'Redemption amount',
    receive_amount: 'Prize amount',
    address: 'Address',
    no_transaction: 'No transaction',
    no_more: 'No more',
    loading: 'Loading...',
    holdings: 'Holdings',
    total_amount_of_tokens: 'Total amount of tokens',
    contract_address: 'Contract address',
    number_of_accounts: 'Number of accounts',
    quantity: 'Quantity',
    total: 'xxx in total',
    pub: 'Pubic BlockChain Development Assistant Platform',
    userList: 'User list',
    Username_can_not_be_empty:'Username can not be empty',
    Password_cannot_be_less_than_5_digits:'Password cannot be less than 5 digits',
    RPC_service: "RPC",
    address: "Address",
    chain: "Chain",
    default: 'Default',
    Account: 'Account',
    create: 'Create',
    Please_enter_the_file_name: 'Please enter the file name',
    Main_sol: 'The necessary file Main.sol, otherwise it will not be saved!',
    Solidity5: 'Solidity version 0.5.0',
    Are_you_sure: "Are you sure?",
    Delete: "Delete",
    want_to_delete: "Are you sure you want to delete",
    cannot_be_undone: "This operation cannot be undone!",
    Ispublic: "Is it public:",
    Contract_description: "Contract description:",
    version: "Version:",
    Save_as_contract_template: 'Save as contract template',
    Reward_on_POS_chain: 'Reward on POS chain',
    POS_node_awards: 'POS node awards',
    Please_enter_the_address: "Please enter the address",
    Please_enter_the_correct_address: "Please enter the correct address",
    Select_or_enter_the_query_address: "Select or enter the query address",
    Please_enter_input: "Please enter input",
    Serial_number: "No",
    name: "Name",
    Chain_id: "Chain id",
    nonce: "Nonce",
    Balance: "Balance",
    Creation_time: "Creation time",
    time: 'Time',
    operate: "Operate",
    common: "Common",
    strip: "Strip",
    Check: "Check",
    title: "Title",
    Public_key: "Public key",
    Private_key: "Private key",
    Cancel: "Cancel",
    Sure: "Sure",
    Contract_name: "Contract name",
    Please_enter_the_contract_name: "Please enter the contract name",
    publisher: "Publisher",
    Contract_template: "Contract template",
    NewaddContract_template: "New contract template",
    ReviseContract_template: "Modify contract template",
    username: "Username",
    Please_enter_username: "please enter user name",
    Please_enter_password: "please enter password",
    login: 'Login',
    Private_key_or_mnemonic: "Private key or mnemonic",
    Do_not_enter_the_default_creation_private_key: "Do not enter the default creation private key",
    Check_balances: "Check balances",
    search_history: "Search history",
    cannot_be_empty:"The address for checking the balance operation cannot be empty!",
    logout:"Please choose whether to proceed with the logout operation?",
    information: "Information",
    Compile: "Compile",
    Run: "Run",
    Add_to: "Add to",
    Revise: "Revise",
    Remark: "Remark",
    Please_enter_a_note: "Please enter a note",
    release: "Release",
    Publish_hash: "Publish hash",
    Contract_address: "Contract address",
    Publisher_address: "Publisher address",
    TKM_before_launch: "TKM before launch",
    Post_launch_TKM: "Post-launch TKM",
    Gas_fee: "Gas fee",
    release_time: "Release time",
    state: "State",
    Refresh: "Refresh",
    No_data: "No data",
    environment: "Environment",
    Self_built: "Self-built",
    system: "System",
    local: "Local",
    contract: "Contract",
    XTO_quantity: "XTO quantity",
    UserA_to_userB0: "Please select the contract first, user A transfers money to user B, user B’s address is optional and can be entered",
    UserA: "UserA",
    UserA_address: "UserA address",
    UserB: "UserB",
    UserB_address: "UserB address",
    designated_address: "Designated address,",
    designated_placeholder1: "Batch conversion format:",
    designated_placeholder2: "address, balance;",
    designated_placeholder3: "E.g:",
    Please_enter_the_number_ofXTO: "Please enter the number of XTO",
    transfer: "Transfer",
    Award: "Award",
    // Please_enter_the_correct_address_of_the_prize_issuer!:"Please enter the correct address of the prize issuer!",
    Transfer_address: "Transfer address",
    Amount_before_transfer: "Amount before transfer",
    Amount_after_transfer: "Amount after transfer",
    Payee_address: "Payee address",
    Amount_before_payment: "Amount before payment",
    Amount_after_receipt: "Amount after receipt",
    Test_case: "Test case",
    please_choose: "Please choose",
    refresh_the_list: "Refresh the list",
    Generate_sig: "Generate sig",
    Send_sig_transaction: "Send sig transaction",
    Please_select_or_enter_Form: "Please select or enter Form",
    Please_select_contract_address: "Please select contract address",
    Select_sig_type: "Select sig type",
    Please_select_the_chain: "Please select the chain",
    Contract_method: "Contract method",
    Method_entry: "Method entry",
    Initiate_transaction: "Initiate transaction",
    Save_the_use_case: "Save the use case",
    Delete_use_case: 'Delete use case',
    Update_use_case: 'Update use case',
    Use_case_name: 'Use case name',
    Please_enter_the_use_case_name: 'Please enter the use case name',
    Reverse_input: "Reverse input",
    theme: "Theme",
    Collapse_all: "Collapse all",
    Automatically_detect_conversion_addresses: "Automatically detect conversion addresses, batch conversion, carriage return and line feed between addresses",
    Please_enter_user_address: "Please enter user address",
    Conversion: "Conversion",
    Please_enter_content: "Please enter content",
    format: "Format",
    Generate_public_and_private_keys: "Generate public and private keys",
    Return_public_key_and_address_via_private_key: "Return public key and address via private key",
    Please_enter_the_private_key: "Please enter the private key",
    Obtain: "Obtain",
    encryption: "Encryption",
    Decrypt: "Decrypt",
    please_enter: "Please enter",
    UserA_to_userB1: "UserA transfers money to UserB. UserB's address is optional and can be entered",
    Owning_chain: "Owning chain",
    transfer_amount: "Transfer amount",
    Please_enter_the_transfer_amount: "Please enter the transfer amount",
    Amount: "Amount",
    search: "Search",
    Please_enter_the_address: "Please enter the address",
    Transaction_hash: "Transaction Hash",
    Timestamp: "Timestamp",
    organizer: "Organizer",
    receiver: "Receiver",
    TransactionType: "Transaction Type",
    Transfer_transaction: "Transfer transaction",
    Token_award: "Token award",
    Contract_release: "Contract release",
    Ordinary_contract_transaction: "Ordinary contract transaction",
    PoC_lock: "PoC lock",
    PoC_awards: "PoC awards",
    PoC_redemption: "PoC redemption",
    PoS_award: "PoS award",
    PoS_lock: "PoS lock",
    PoS_award: "PoS award",
    Transfer_transaction: "Transfer transaction",
    Cross_chain_transaction_withdrawal: "Cross-chain transaction withdrawal",
    Cross_chain_transaction_deposit: "Cross-chain transaction deposit",
    Cross_chain_transaction_cancellation: "Cross-chain transaction cancellation",
    Contract_transaction: "Contract transaction",
    In_chain_transactions: "In-chain transactions",
    Cross_chain_transaction: "Cross-chain transaction",
    CreateWallet: "Create a wallet",
    Mnemonic: "Mnemonic",
    Mnemonic_to_generate_private_key: "Mnemonic to generate private key",
    Enter_the_mnemonic: "Enter the mnemonic",
    Private_key_export_public_key: "Private key export public key",
    Enter_private_key: "Enter private key",
    Public_key_export_address: "Public key export address",
    Enter_public_key: "Enter public key",
    Wallet_generator: "Wallet generator",
    Method_call: "Method call",
    SDK_download: "SDK download",
    sig_type: "Sig type",
    Transaction_amount: "Transaction amount",
    Please_enter0x: "Please enter the private key starting with 0x",
    Read_before_downloading: "Read before downloading",
    Read_before_downloading1: "1. Computer configuration node.js (recommended version 12.15.0). address:",
    Read_before_downloading2: "2. Install vue-cli (4.x) globally. Execute in the controller:",
    Read_before_downloading3: "3. Click the button",
    Read_before_downloading_Download: 'SDK (1.0.5):"Download SDK (1.0.5)"',
    Read_before_downloading4: "4. Enter the sdk project, install the project dependencies, execute in the root directory: npm install",
    Read_before_downloading5: "5. Start the project and execute in the project root directory: npm run serve",
    Read_before_downloading6: "6. Package, execute in project root directory: npm run build, generate dist file",
    Project_file_description: "Project file description",
    Interface_docking_instructions: "Interface docking instructions",
    Interface_document_address: "Interface document address",
    Interface_docking_instructions1: "After registration, ask the administrator for permission and check the corresponding interface document.",
    Interface_docking_instructions2: "Interface documentation, when debugging, you can install plug-ins to view the callback results. (Similar to Postman)",
    Interface_docking_instructions3: "The interface uses AES to encrypt the private key, sends it to the contract service, and initiates a chain transaction.",
    Interface_docking_instructions4: "The AES key corresponding to the businessId can be obtained from the administrator.",
    dev_assistant_platform: 'Dev Assistant Platform',
    get_contract_releas_code: 'Get the contract release code',
    enter_address_compared: 'Please enter the address to be compared',
    Compare_addresses: 'Compare addresses',

    // No transaction
    // 取引なし
    // 거래 없음
  },
  prompt: {
    prompt_2: 'Note: The main chain and the sharded task chain only record member elections on the chain, and do not record general transactions. The number of election transactions is not counted in the transaction chain.',
  },
  placeholder: {
    placeholder_1: 'Please enter the block height',
    placeholder_2: 'Please enter the transaction hash/account address',
    placeholder_3: 'Please enter block height/block hash',
    placeholder_4: 'Please enter block height/transaction hash/transaction address',
    placeholder_5: 'Please enter the transaction hash',
    placeholder_6: 'Please enter transaction hash/block height/block hash query',
    search: 'Search',
    filter: 'Filter',
    view_all_blocks: 'View all blocks',
    view_all_tr: 'View all transactions',
    choose: 'Please choose',
    placeholder_7: 'Please enter account address, transaction hash',
    placeholder_8: 'Please enter block hash / transaction hash / user address'
  },
  table: {
    transfer_via_contract: 'Transfer via contract',
    direct_transfer: 'Direct transfer',
    subchain_id: 'Task chain ID',
    block_height: 'Block height',
    current_committee_member: 'Current committee members',
    number_of_committee_members: 'Committee members',
    elected_member: 'Candidates',
    number_of_fragments: 'Number of shards',
    total_share_of_its_segmented_chain: 'Total transaction volume of its trading chain',
    miner: 'Miner',
    trading_volume: 'Trading volume',
    transaction_hash: 'Transaction Hash',
    own_chain: 'Belonging Chain',
    timestamp: 'Timestamp',
    transaction_type: 'Transaction Type',
    initiator: 'Initiator',
    receiver: 'Receiver',
    transfer_amount: 'Transfer amount',
    transaction_fee: 'Transaction fee',
    block_hash: 'Block hash',
    total_number_of_transactions: 'Total transactions',
    state: 'Status',
    ov_block: 'Own block',
    tr_peo: 'Transferor',
    send_ch: 'Issue chain',
    get_ch: 'Receiving chain',
    input_data: 'Input data',
    is_user: 'Caller',
    contract: 'Contract',
    committee_member_details: 'Committee Member Details',
    generated_block_information: 'Block information generated',
    ac_any: 'Account balance',
    ac_any_other: 'Amount of each task chain',
    ac_num: 'Amount in contract',
    issuer: 'Issuer',
    recipient: 'Receiver',
    call_record: 'Call record',
    cross_chain_transfer_contract: 'Cross-chain transfer contract',
    order: 'Serial number',
    nodeID: 'Node ID',
    currentStatus: 'Current status',
    mineID: 'Mining pool ID',
    pitManagementFee: 'Pool management fee',
    remainingAmount: 'Remaining amount',
    TokensTrading: 'Token transaction',
    token_prizes: 'Token award',
    token_transfer_accounts: 'Token transfer',
    has_abandoned_the_award_waiting_for_approval: 'Abandoned receiving the prize, awaiting approval',
    have_been_approved: 'Approved',
    approved_not_approved: 'Not approved',
    has_the_prize: 'Awards received',
  },
  download: {
    sdkdownload: 'SDK download',
    apidownload: 'API download',
    Software_package: 'Software package',
    version: 'Version',
    size: 'Size',
    update_time: 'Update time',
    document_description: 'Document description',
    software_address: 'Software address',
    view: 'View',
    _download: 'Download',
  },
  select: {
    all: 'All',
    within_chain_trading: 'Intrachain transactions',
    contract_trading: 'Contract transaction',
    across_chain_trading: 'Cross-chain transaction',
    contract_issued: 'Contract release',
    common_contract_trading: 'Ordinary contract transaction',
    other_lock: 'Other locks',
    poc_prizes: 'PoC award',
    poc_redemption: 'PoC redemption',
    poc_generation: 'PoC proxy',
    pos_lock: 'PoS lock',
    pos_prizes: 'PoS award',
    pos_award: 'PoS receives the award',
    across_chain_trading_withdrawal: 'Cross-chain transaction withdrawal',
    across_chain_trading_deposit: 'Cross-chain transaction deposit',
    across_chain_trading_repeal: 'Cancellation of cross-chain transactions',
    transfer_transaction: 'Transfer transaction',
    order_on_chain: 'Order on chain'
  }
}